import { createReducer } from '@reduxjs/toolkit';

import constants from './constants';
import actions from './actions';
import { ValueOf } from '../../globalTypes';

const {
  DEVELOPER_DRAWER_TABS,
  DEVELOPER_DRAWER_DEFAULT_HEIGHT,
  DEVELOPER_DRAWER_DEFAULT_WIDTH,
} = constants;

type DeveloperDrawerState = {
  readonly currentTab: ValueOf<typeof DEVELOPER_DRAWER_TABS>;
  readonly height: string;
  readonly isHorizontal: boolean;
  readonly isOpen: boolean;
  readonly width: string;
};

const initialState: DeveloperDrawerState = {
  currentTab: DEVELOPER_DRAWER_TABS.DEVICE_LOGS,
  height: DEVELOPER_DRAWER_DEFAULT_HEIGHT,
  isHorizontal: false,
  isOpen: false,
  width: DEVELOPER_DRAWER_DEFAULT_WIDTH,
};

const developerDrawerReducer = createReducer(initialState, (builder) => {
  builder.addCase(actions.setDeveloperDrawerOpen, (draft, { payload }) => {
    draft.isOpen = payload;
  });

  builder.addCase(actions.setDeveloperDrawerHeight, (draft, { payload }) => {
    draft.height = payload;
  });

  builder.addCase(actions.setDeveloperDrawerWidth, (draft, { payload }) => {
    draft.width = payload;
  });

  builder.addCase(actions.setDeveloperDrawerHorizontal, (draft, { payload }) => {
    draft.isHorizontal = payload;
  });

  builder.addCase(actions.setDeveloperDrawerCurrentTab, (draft, { payload }) => {
    draft.currentTab = payload;
  });
});

export default developerDrawerReducer;
export {
  initialState,
};
export type {
  DeveloperDrawerState,
};
